import { Injectable } from '@angular/core';
import { ReportModel, ReportType } from '../models/reports-model';

@Injectable({
    providedIn: 'root'
})
export class ReportSelectService {
    private reports: ReportModel[] = [
        { id: 1, name: 'Labour Report', route: 'payrollReport', type: ReportType.PayrollReport },
        { id: 2, name: 'Club-Centric cost Report', route: 'clubCentricReport', type: ReportType.ClubCentricReport },
        { id: 3, name: 'Attendance Report', route: 'attendanceReport', type: ReportType.AttendanceReport },
        { id: 4, name: 'Instructor-Centric Report', route: 'instructorCentricReport', type: ReportType.InstructorCentricReport },
        { id: 5, name: 'Online-Content-View Report', route: 'onlineContentViewReport', type: ReportType.OnlineContentViewReport },
        { id: 6, name: 'ADP report', route: 'adpReport', type: ReportType.AdpReport },
    ];
    constructor() {}

    getReports(): ReportModel[] {
        return this.reports;
    }
    getReport(reportType: ReportType) {
        return this.reports.find(p => p.type === reportType);
    }
}
